// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    eventbookingCommentList as eventbookingCommentListApi,
    eventbookingCommentUpdateStatus as eventbookingCommentUpdateStatusApi,
    eventbookingCommentCreate as eventbookingCommentCreateApi,
    eventbookingCommentUpdate as eventbookingCommentUpdateApi,
    eventbookingCommentDelete as eventbookingCommentDeleteApi
} from "../../../helpers/api/eventbooking_comment"

import {
    authApiResponseSuccess,
    authApiResponseError,
} from "./actions"
import { EventbookingCommentActionTypes } from './constants';


function* list() {
    try {
        const response = yield call(eventbookingCommentListApi);
        const eventbooking_comments = response.data

        console.log(eventbooking_comments)

        yield put(authApiResponseSuccess(EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT, eventbooking_comments));
    } catch (error) {
        yield put(authApiResponseError(EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT, error));
    }
}


function* updateEventbookingCommentStatus(action) {

    try {
        const response = yield call(eventbookingCommentUpdateStatusApi, {eventbooking_id: action.payload.eventbooking_id});

        yield put(authApiResponseSuccess(EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT, {eventbookings: response.data.eventbookings }));
    } catch (error) {
        yield put(authApiResponseError(EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT, error));
    }
}

function* createEventbookingComment(action) {

    try {
        const response = yield call(eventbookingCommentCreateApi, {id: action.payload.id, data: action.payload.data});

        yield put(authApiResponseSuccess(EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT, { eventbookings: response.data.eventbookings, id: action.payload.data }));
    } catch (error) {
        yield put(authApiResponseError(EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT, error));
    }
}

function* updateEventbookingComment(action) {

    try {
        const response = yield call(eventbookingCommentUpdateApi, {id: action.payload.id, data: action.payload.data});

        yield put(authApiResponseSuccess(EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT, { eventbookings: response.data.eventbookings, id: action.payload.data }));
    } catch (error) {
        yield put(authApiResponseError(EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT, error));
    }
}

function* deleteEventbookingComment(action) {

    try {
        const response = yield call(eventbookingCommentDeleteApi, {id: action.payload.id});

        yield put(authApiResponseSuccess(EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT, { eventbookings: response.data.eventbookings }));
    } catch (error) {
        yield put(authApiResponseError(EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT, error));
    }
}

export function* watchEventbookingCommentList(): any {
    yield takeEvery(EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT, list);
}

export function* watchEventbookingCommentUpdateStatus(): any {
    yield takeEvery(EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT, updateEventbookingCommentStatus);
}

export function* watchEventbookingCommentCreate(): any {
    yield takeEvery(EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT, createEventbookingComment);
}

export function* watchEventbookingCommentUpdate(): any {
    yield takeEvery(EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT, updateEventbookingComment);
}

export function* watchEventbookingCommentDelete(): any {
    yield takeEvery(EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT, deleteEventbookingComment);
}

function* eventbookingCommentSaga(): any {
    yield all([
        fork(watchEventbookingCommentList),
        fork(watchEventbookingCommentUpdateStatus),
        fork(watchEventbookingCommentCreate),
        fork(watchEventbookingCommentDelete),
        fork(watchEventbookingCommentUpdate),
    ]);
}

export default eventbookingCommentSaga;
